import React, { useState } from "react";
import {
  Box,
  Tooltip,
  SwipeableDrawer,
  IconButton,
  Stack,
} from "@mui/material";
import {
  MenuBook as MenuBookIcon,
  MailOutline as MailOutlineIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";

import { CONTENT_HEIGHT, COLOR_SCHEMA } from "../../constants";
import { useTheme } from "../../hooks";
import { ContactUs } from "./ContactUs";
import { Settings } from "../Settings";

export const Sidebar = () => {
  const [openDrawer, setOpenDrawer] = useState<string | null>(null);
  const { mode } = useTheme();

  const toggleDrawer = (open: string | null) => (
    event: React.KeyboardEvent | React.MouseEvent
  ) => {
    if (
      event &&
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }
    setOpenDrawer(open);
  };

  return (
    <Box
      display="flex"
      minHeight={CONTENT_HEIGHT}
      bgcolor={COLOR_SCHEMA[mode].base}
      borderRight={1}
      borderColor="divider"
    >
      <Stack spacing={1} padding={1}>
        <Tooltip title="See documentation">
          <IconButton
            href="https://docs.kodjin.com/operation-apply-fhirpath/"
            target="_blank"
          >
            <MenuBookIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Contact us">
          <IconButton href="mailto:welcome@edenlab.io">
            <MailOutlineIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Settings">
          <IconButton onClick={toggleDrawer("settings")}>
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      </Stack>

      <SwipeableDrawer
        anchor={"right"}
        open={openDrawer === "contact"}
        onClose={toggleDrawer(null)}
        onOpen={toggleDrawer("contact")}
      >
        <ContactUs />
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor={"right"}
        open={openDrawer === "settings"}
        onClose={toggleDrawer(null)}
        onOpen={toggleDrawer("settings")}
      >
        <Settings />
      </SwipeableDrawer>
    </Box>
  );
};
